<div class="offerwrapper acvis-elevation" (dragover)="dragOver($event)" (drop)="dropp($event)">
    <div class="offerheader">
        <span multilang class="offerheadertext"><b>Angebot Nr. {{index()}}</b> Nur Flug</span>
        <ng-container *ngIf="currentCustomer?.asPartner">
            <div class="actions">
                <mat-icon class="rmico mr3" (click)="openSetComment()" matTooltip="Extra info">comment
                </mat-icon>
                <button [draggable]="true" class="drg mr3" matTooltip="Position ändern"
                    (dragstart)="dragStart($event, index())">
                    <svg _ngcontent-soh-c164="" width="24px" fill="currentColor" viewBox="0 0 24 24">
                        <path _ngcontent-soh-c164=""
                            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                        </path>
                        <path _ngcontent-soh-c164="" d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                </button>
                <mat-icon class="rmico" (click)="removeFromListF()" matTooltip="Angebot löchen">cancel
                </mat-icon>
            </div>
        </ng-container>
    </div>
    <div class="offerbody">
        <div class="offerimgwrapper">
            <img src="../../assets/images/air.jpeg" class="lazyload offerimg" alt="FLug">
        </div>

        <div class="offerOperator" [style.background-color]="online()?.length > 0 ? '#ace59f': ''">
            <img src="../../../../assets/images/cockpit.svg" class="lazyload" height="24px" alt="{{datas?.type}}">
            <span multilang style="font-weight: 500;">{{datas?.type}}</span>
        </div>
        <div class="offerschedule">
            <mat-icon class="unsetico">event</mat-icon>
            <span multilang class="offerscheduletext">
                <ng-container *ngIf="datas?.dauer > 0">
                    <b>{{datas?.dauer + (datas?.dauer > 1 ? ' Tage' : ' Tag')}}</b>
                </ng-container>
                {{datas?.hinflugs?.[0]?.startDate | date:'dd.MM.yyyy'}}
                {{ datas?.ruckflugs?.length > 0 ? ' - ' + (datas.ruckflugs[0].startDate | date:'dd.MM.yyyy'): ''}}
            </span>
        </div>
        <div class="offerinfos customscroll">
            <div>
                <ng-container *ngIf="datas?.validTo?.length > 0">
                    <div class="fvalidtow">
                        <mat-icon class="ficon mright">event_available</mat-icon>
                        <span multilang class="ftext">Gültig bis {{datas.validTo | date:'EEE, dd.MM.yyyy
                            HH:mm'}}</span>
                    </div>
                </ng-container>
                <!--span class="fpadlr mtop" style="font-size: .8rem;">Flug</span-->
                <div class="fdropw mtop mbottom">
                    <mat-icon class="ficon">flight_takeoff</mat-icon>
                    <span multilang class="fpadlr">
                        <b>{{datas?.hinflugs?.[0]?.departureAirport?.name}}</b>
                        ({{datas?.hinflugs?.[0]?.departureAirport?.code}})
                    </span>
                </div>
                <ng-container *ngIf="datas?.ruckflugs?.length > 0; else oneway">
                    <div class="fdropw mbottom">
                        <mat-icon class="ficon">flight_land</mat-icon>
                        <span multilang class="fpadlr">
                            <b>{{datas.ruckflugs[0].departureAirport?.name}}</b>
                            ({{datas.ruckflugs[0].departureAirport?.code}})
                        </span>
                    </div>
                </ng-container>
                <ng-template #oneway>
                    <div class="fdropw mbottom">
                        <mat-icon class="ficon">flight_land</mat-icon>
                        <span multilang class="fpadlr">
                            <b>{{datas?.hinflugs?.[datas.hinflugs.length - 1]?.arrivalAirport?.name}}</b>
                            ({{datas?.hinflugs?.[datas.hinflugs.length - 1]?.arrivalAirport?.code}})
                        </span>
                    </div>
                </ng-template>
                <mat-divider></mat-divider>
                <div class="fdropw mtop">
                    <mat-icon class="ficon">airlines</mat-icon>
                    <span multilang class="fpadlr">{{datas?.hinflugs?.[0]?.carrier}}</span>
                </div>
                <div class="fdropw mtop">
                    <mat-icon class="ficon">luggage</mat-icon>
                    <span multilang class="fpadlr">{{datas?.hinflugs?.[0]?.gepack}}</span>
                </div>
                <div class="fdropw mtop">
                    <mat-icon class="ficon">class</mat-icon>
                    <span multilang class="fpadlr">{{datas?.hinflugs?.[0]?.cabinClass}}</span>
                </div>
                <div class="fdropw mtop">
                    <mat-icon class="ficon">airline_stops</mat-icon>
                    <span multilang class="fpadlr">{{datas?.hinflugs?.length - 1}} Stopp</span>
                </div>
            </div>
            <div class="offerinfodet fpadlr" (click)="openDetail()">
                <span multilang class="minbtn noselect" matRipple>Mehr Details</span>
            </div>
        </div>
        <div class="offerprice">
            <span multilang>
                <span multilang *ngIf="datas?.adult?.length > 0">Erwachsene : {{datas?.adult}}</span>
                <span multilang style="margin-left: .5rem;" *ngIf="datas?.childrenCount?.length > 0">Kinder :
                    {{datas?.childrenCount}}</span>
            </span>
            <div class="offerpriceTotal">
                <span multilang>Gesamtpreis:</span>
                <span multilang class="prccolor">{{datas?.price | number:'1.2-2'}} {{datas?.currency}}</span>
            </div>
        </div>
        <button class="mhrd" (click)="gotoBuchen();">
            <div class="noselect bookingbtn">
                {{currentCustomer?.token?.length > 0 ? 'Buchen' : 'Anfrage senden'}}
            </div>
        </button>
    </div>
</div>

<ng-container *ngIf="showDetail">
    <clever-offerpackdetailmodal (triggerCloseModal)="closeModal($event)"
        [cmpRef]="component"></clever-offerpackdetailmodal>
</ng-container>